import request from '@/utils/request'

/**
 * 查询管理员拼团订单
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryAdminGroupOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.queryAdminGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询管理员店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}